import { useContext } from 'react'
import AuthContext from 'modules/auth/context/AuthContext'

export default function useAuth() {
  return useContext(AuthContext)
}